import React from "react";
import "./styles.scss";
import bilansData from "../../../assets/data/bilans";

import FormationCell from "../../../components/FormationCell";
import EvaluateCard from "../../../components/EvaluateCard";

type BilansSectionProps = {
  openIndicateursPerformanceModal: any;
  openFinancementsModal: any;
};

const BilansSection: React.FC<BilansSectionProps> = ({
  openIndicateursPerformanceModal,
  openFinancementsModal
}) => {
  return (
    <section className="bilans-section" id="bilans">
      <h2>Bilans de carrière et de compétences</h2>
      <p>
        Le bilan de compétences est une démarche enrichissante qui offre une
        pause réflexive pour évaluer vos compétences professionnelles et
        personnelles, ouvrant la voie à une évolution de carrière ciblée et
        consciente. C’est un outil puissant pour redéfinir vos objectifs
        professionnels, découvrir de nouvelles opportunités et aligner vos
        aspirations avec vos véritables talents.
      </p>
      <br />
      <EvaluateCard
        titles={[
          "Vous vous interrogez sur votre avenir professionnel ?",
          "Avant de vous lancer, vérifiez si le bilan de compétences est vraiment ce qu’il vous faut. Répondez à ces 6 questions en toute honnêteté : en quelques secondes, vous saurez si cet accompagnement peut vous aider à (re)trouver du sens et à passer à l’action."
        ]}
        questions={[
          "Ressentez-vous une envie de changer de poste ou de métier sans savoir précisément quoi faire ?",
          "Avez-vous l’impression de ne plus être à votre place dans votre travail actuel ?",
          "Avez-vous du mal à identifier vos véritables atouts ou talents professionnels ?",
          "Vous sentez-vous bloqué(e) pour évoluer dans votre carrière ?",
          "Avez-vous besoin d’être accompagné(e) pour faire le point et clarifier un projet réaliste ?",
          "Souhaitez-vous être conseillé(e) pour identifier des formations ou des pistes concrètes ?"
        ]}
        subtitle={
          "Vous avez coché plusieurs « Oui » ? Ne restez pas seul(e) : prenez rendez-vous dès maintenant pour échanger gratuitement sur vos besoins et vos objectifs !"
        }
      />
      <div className="formation-cells-container">
        {bilansData.map((bilan, index) => (
          <FormationCell
            key={index}
            image={bilan.image}
            title={bilan.title}
            description={bilan.description}
            id={bilan.id}
            content={bilan.content}
            type={bilan.type}
            sectionType={"bilan"}
            onOpenIndicateursPerformanceModal={() =>
              openIndicateursPerformanceModal(bilan.type, bilan.id)
            }
            onOpenFinancementsModal={() => openFinancementsModal(bilan.type)}
          />
        ))}
      </div>
    </section>
  );
};

export default BilansSection;
